<template>
  <modal
    class="editPumpStat"
    name="accountCompanySettlement"
    transition="pop-out"
    :width="600"
    :height="620"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="30" height="30"
      /></span>
      <h4>{{ $t("text.bServices.transactionDet") }}</h4>
    </div>
    <div class="container my-2">
      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.salesTransactions.amount") }}:
        </div>
        <div class="col-7 text-left">{{ details.amount }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.branch.cat") }}:
        </div>
        <div class="col-7 text-left">{{ details.category }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.retainership.channel") }}:
        </div>
        <div class="col-7 text-left">{{ details.channel }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.walletTransactions.date") }}:
        </div>
        <div class="col-7 text-left">{{ details.date }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.walletTransactions.description") }}:
        </div>
        <div class="col-7 text-left">{{ details.description }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.walletTransactions.newBal") }}:
        </div>
        <div class="col-7 text-left">{{ details.newBalance }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-5 font-weight-bold text-right">
          {{ $t("text.cBank.transactionRef") }}:
        </div>
        <div class="col-7 text-left">{{ details.transactionReference }}</div>
      </div>
      <section v-if="moreDetails">
        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.cards.consumedAmount") }}:
          </div>
          <div class="col-7 text-left">{{ details.consumedAmount }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.retainership.orderDate") }}:
          </div>
          <div class="col-7 text-left">{{ details.orderDate }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.bWallet.product") }}:
          </div>
          <div class="col-7 text-left">
            {{ details.product ? details.product : "---" }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.cServices.price") }}:
          </div>
          <div class="col-7 text-left">{{ details.pricePerLiter }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.form.state") }}:
          </div>
          <div class="col-7 text-left">{{ details.state }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.bankAccounts.type") }}:
          </div>
          <div class="col-7 text-left">{{ details.type }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.pumpTransactions.volumeDispensed") }}:
          </div>
          <div class="col-7 text-left">{{ details.volumeDispensed }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.cards.usageLocation") }}:
          </div>
          <div class="col-7 text-left">
            {{ details.usageLocation ? details.usageLocation.address : "---" }}
          </div>
        </div>
      </section>

      <section v-else>
        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.walletTransactions.currentBalance") }}:
          </div>
          <div class="col-7 text-left">{{ details.currentBalance }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.aaDetailsModal.refNumber") }}:
          </div>
          <div class="col-7 text-left">{{ details.referenceNumber }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.iEvents.source") }}:
          </div>
          <div class="col-7 text-left">{{ details.source }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-5 font-weight-bold text-right">
            {{ $t("text.iWalletTransactions.status") }}:
          </div>
          <div class="col-7 text-left">{{ details.status }}</div>
        </div>
      </section>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";
import moment from "moment";

export default {
  name: "accountsCompanySettlements",
  props: ["details", "moreDetails"],
  data() {
    return {
      date: "",
      amount: null,
      transactionType: null,
      close: false,
      isButtonDisabled: false,
      showSpinner: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    toggleIsClosed() {
      this.close = !this.close;
    },
  },
};
</script>
